export enum ContactTopic {
    GENERAL_QUESTION = "GENERAL_QUESTION",
    TECHNICAL_ISSUE = "TECHNICAL_ISSUE"
}

export const CONTACT_TOPICS: ContactTopic[] = [
    ContactTopic.GENERAL_QUESTION,
    ContactTopic.TECHNICAL_ISSUE
];